import { css } from "@emotion/css";
import { PropsWithChildren, useContext } from "react";
import { Heading } from "react-aria-components";

import { DialogTriggerContext } from "./DialogTrigger";
import { getTextStyle } from "../../foundations/typography/styles";
import { GhostIconButton } from "../button/GhostIconButton";

interface Props extends PropsWithChildren {
  canClose?: boolean;
}

export function PopoverHeading(props: Props) {
  const { canClose = true } = props;

  const { toggle } = useContext(DialogTriggerContext);

  return (
    <div className={styles.headingContainer}>
      <Heading className={styles.heading}>{props.children}</Heading>
      {canClose && (
        <div className={styles.closeButtonContainer}>
          <GhostIconButton icon="close" size="small" onPress={toggle} />
        </div>
      )}
    </div>
  );
}

const styles = {
  headingContainer: css({
    alignItems: "flex-end",
    display: "flex",
    justifyContent: "space-between",
  }),
  heading: css(
    {
      margin: 0,
      paddingBottom: "var(--space-1)",
      paddingLeft: "var(--space-4)",
      paddingTop: "var(--space-2)",
    },
    getTextStyle("global/heading-medium")
  ),
  closeButtonContainer: css({ padding: "var(--space-1)", paddingBottom: 0 }),
};
